<template>
    <section class="page-404 container-fluid flex-center bg-info">
        <div class="text-center">
            <span class="title-lg poppins-black text-success"> 404 </span> <br>
            <span class="description-md text-white text-capitalize"> Page Not Found </span>
        </div>
    </section>
</template>

<script setup>

</script>

<style lang="scss" scoped>
    .page-404 {
        height: 100vh;
    }
</style>
